import { createContext } from 'react';

import { NofomoLoyaltyStoreReturnType } from './zustand';

export const NofomoLoyaltyStoreContext =
  createContext<NofomoLoyaltyStoreReturnType | null>(null);
